import {checkEmpty,checkPhone,mcToast,sendLog} from "../../../util/util"
import {provinceArr} from "../../../util/data"
import loading from '../../../components/loading/index.vue'
export default {
    data() {
        return {
            name:'',
            phone:'',
            address:'',
            account:'',
            prizeInfo:{prizeId:70},
            accountPower:true,
            showAreaSelect:false,//锁号地区下拉
            area:'',
            areaTemp:'',
            onlyRead:false,//只读
            areaSlots:[{
               flex: 1,
               defaultIndex: 0, 
               values: provinceArr, //省份数组
               className: 'slot1',
               textAlign: 'center'
            }],
            showLoading:false,  
            tkRotate:true,          
        }
    },
    components: {
        loading
    },
    created() {      
      if (!this.$route.params.flagStr) {
        this.$router.push({
                path: '/memberDay/memberDayIndex',
                name: 'memberDayIndex',
            })
      }
      this.showLoading=true;
      axios.post('/hd/lottery?'+this.$route.params.flagStr+'&times='+this.$route.params.times).then(res => {
        this.prizeInfo=res.data.data.lotteryInfo[0];
        if (this.prizeInfo.status==1) {//0是信息未完善 1是信息已完善
          this.onlyRead=true;
          this.name=this.prizeInfo.name;
          this.phone=this.prizeInfo.phone;
          this.address=this.prizeInfo.address;
        }
        this.prizeInfo.accountName=this.prizeInfo.accountName?this.prizeInfo.accountName:this.$route.params.accountName
        this.showLoading=false;
        if (this.$route.params.flagStr && this.$route.params.flagStr.indexOf('lockCode')>-1) {
          this.accountPower=false;
        }
      });
    },
    methods: {
        //弹出选择地区的弹框
        clickArea(){
          if (!this.onlyRead) {
            this.showAreaSelect=true;
          }
          
        },
        // 选择地区
        areaChange(picker, values){
            this.areaTemp=values[0];
        },
        // 选择地区确定
        areaConfirm(){
            this.showAreaSelect=false;
            this.area=this.areaTemp.name;
        },
        //提交
        confimDownload(){
            sendLog("1465");
            window.open(this.prizeInfo.docUrl)
            this.$axios.post("/hd/prize/download?id="+this.prizeInfo.id).then(res=>{
            })
            
        },
        // 权益1是当前账号 2是新账号
        confirmAccount(num){
            sendLog("1464");
            if (num==2 && !(checkEmpty(this,this.account,'请输入要授权的账号'))) {
                  return
            }
            let accountName=num==1?this.prizeInfo.accountName:this.account;
            this.$axios.post("/hd/prize/grantInterest?id="+this.prizeInfo.id+"&accountName="+accountName).then(res=>{
                if (res && res.data && res.data.code==200) {
                    mcToast('恭喜您，授权成功');
                    setTimeout(() => { this.$router.back() }, 2000);
                }else{
                    mcToast(res.data.msg);
                }
                
            })
        },
        // 提交礼品
        confimSend(){
            sendLog("1466");
            if (!(checkEmpty(this,this.name,'请输入姓名') 
                    && checkEmpty(this,this.phone,'请输入手机号码')
                    && checkEmpty(this,this.address,'请输入地址')
                    && checkPhone(this,this.phone,'手机号码输入有误'))) {
                  return
            }else{
                this.$axios.post("/hd/prize/postal?id="+this.prizeInfo.id+"&name="+this.name+"&phone="+this.phone+"&address="+this.address).then(res=>{
                    if (res && res.data && res.data.code==200) {
                      mcToast('恭喜您，提交成功');
                      setTimeout(() => { this.$router.back() }, 2000);
                    }else{
                      mcToast(res.data.msg);
                    }
                })
            }
        },
        back(){
            this.$router.back()
        },
    },
}